import React from 'react';
import { Card, CardMedia, CardContent, Typography, Button, Box, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Item } from '../../utilities/types';
import { parseIntoNumber, prepareAndGetMediaURL } from '../../utilities/helper';
import useNavigateHook from '../../hooks/navigate.hook';

interface ItemWidgetProps {
  item: Item;
  stats?: React.ReactNode;
}

const ItemWidget: React.FC<ItemWidgetProps> = ({ item, stats }) => {
  const { doNavigate } = useNavigateHook();

  const redirectToAuctions = () => {
    doNavigate(`auctions.html?item_id=${item.id}`);
  };

  return (
    <Card
      sx={{
        maxWidth: 360,
        borderRadius: 3,
        boxShadow: 3,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: 6,
        },
      }}
    >
      {/* Image Banner */}
      <CardMedia
        component="img"
        height="180"
        image={prepareAndGetMediaURL(item.image)}
        alt={item.name}
      />

      {/* Content */}
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            {item.name}
          </Typography>
          <Chip
            label={`${parseIntoNumber(item?.live_auctions_count)} Auction(s)`}
            color="success"
            variant="outlined"
            sx={{ fontWeight: 'bold', backgroundColor: '#e6f4ea' }}
          />
        </Box>
        {item.description && (
          <Typography variant="body2" color="text.secondary" mt={1}>
            {item.description}
          </Typography>
        )}
        {stats && <Box sx={{ my: 2, textAlign: 'center' }}>{stats}</Box>}
        <Button
          variant="contained"
          fullWidth
          color="success"
          endIcon={<ArrowForwardIcon />}
          sx={{ mt: 2, fontWeight: 'bold', textTransform: 'none' }}
          onClick={redirectToAuctions}
        >
          View Auctions
        </Button>
      </CardContent>
    </Card>
  );
};

export default ItemWidget;
